module.exports = __webpack_public_path__ + "img/all-on.a3eeb651.png";